import { useCallback, useEffect, useState } from "react";

import {
	pushRecentTicketSearch,
	readRecentTicketSearches,
	removeRecentTicketSearch,
	writeRecentTicketSearches,
} from "../helpers/recentTicketSearches";

export default function useRecentTicketSearches(userId) {
	const [items, setItems] = useState(() => readRecentTicketSearches(userId));

	useEffect(() => {
		setItems(readRecentTicketSearches(userId));
	}, [userId]);

	const add = useCallback(
		(term) => {
			setItems(pushRecentTicketSearch(userId, term));
		},
		[userId]
	);

	const remove = useCallback(
		(term) => {
			setItems(removeRecentTicketSearch(userId, term));
		},
		[userId]
	);

	const clear = useCallback(() => {
		setItems(writeRecentTicketSearches(userId, []));
	}, [userId]);

	return { items, add, remove, clear };
}
